<template>
    <div>
        <div class="imageContainer" @click="load()" v-bind:class="{'notLoaded': !src}">
            <div class="text-center uppercase">
                <p v-if="!src">
                    {{ $t('video') }}
                </p>

                <icon v-if="!src" icon="download"></icon>

                <video v-if="src" width="320" height="240" controls @error="onError()" @load="onLoad()">
                    <source :src="src">
                </video>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .imageContainer.notLoaded {
        padding: 30px;
    }

    .imageContainer {
        width: 100%;
        height: auto;
        vertical-align: center;
        cursor: pointer;
    }

    video{
        width: 100%;
        height: auto;
    }
</style>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            message: Object,
            instanceId: String
        },

        inject: ['alert'],

        data() {
            return {
                src: null,
                loaded: false
            }
        },

        methods: {
            load() {
                this.src = this.getMediaUrl();
            },

            onLoad() {
                this.loaded = true;
            },

            getMediaUrl() {
                return Zapin.media().mountLoadUrl(this.instanceId, this.message.id, this.message.quoted);
            },

            onError() {
                this.src = null;
                this.alert.show(this.$t('this_media_is_not_available'));
            }
        }
    }
</script>
